import React, { useState } from 'react';
import Modal from 'react-modal';
import '../ExternalUsers/CreateExternalModal.css';

const SetHolidayModal = ({ isOpen, onClose, holidays, setHolidays }) => {
    const [date, setDate] = useState('');
    const [error, setError] = useState(null);

    const handleAddHoliday = async () => {
        if (!date) {
            setError('Please select a valid date.');
            return;
        }

        // Check if the selected date is before today
        const selectedDate = new Date(date);
        const today = new Date();
        today.setHours(0, 0, 0, 0); // Set time to midnight for accurate comparison

        if (selectedDate < today) {
            setError('You cannot select a date before today.');
            return;
        }

        // Check if the date is already a holiday
        if (holidays.includes(date)) {
            setError('This date is already marked as a holiday.');
            return;
        }

        try {
            const response = await fetch('https://api.hgcdental.clinic/api/holidays', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ date }),
            });

            if (response.ok) {
                window.alert('Holiday added successfully!');
            }

            if (!response.ok) {
                throw new Error('Failed to save holiday');
            }

            const newHoliday = await response.json();
            const updatedHolidays = [...holidays, newHoliday.date];
            setHolidays(updatedHolidays);
            setDate('');
            setError(null);
            onClose(); // Close the modal after adding the holiday
        } catch (error) {
            console.error('Error saving holiday:', error);
            setError('Failed to save holiday. Please try again.');
        }
    };

    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={onClose}
            className="modal"
            overlayClassName="overlay"
        >
            <div className="modal-flex-div">
                <button className="close-icon" onClick={onClose}>&times;</button>
                <h2 className="h2-modal">Add Holiday</h2>
            </div>
            <div className="modal-divider" />

            {error && <div className="error-message">{error}</div>}

            <div>
                <label>Holiday Date*</label>
                <input
                    type="date"
                    value={date}
                    onChange={(e) => setDate(e.target.value)}
                    className="modal-input"
                    min={new Date().toISOString().split('T')[0]} // Prevent selecting dates before today
                    required
                />
            </div>

            <div className="padding-top" />
            <div className="modal-divider-bottom" />
            <div className="padding-top" />

            <button
                type="submit"
                onClick={handleAddHoliday}
            >
                Add Holiday
            </button>
        </Modal>
    );
};

export default SetHolidayModal;